import { render, staticRenderFns } from "./PvcTreeNode.vue?vue&type=template&id=70bec2d1&"
import script from "./PvcTreeNode.vue?vue&type=script&lang=js&"
export * from "./PvcTreeNode.vue?vue&type=script&lang=js&"
import style0 from "./PvcTreeNode.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports